import React from 'react';
import './PublicLegalDocumentLayout.css';

export default function PublicLegalDocumentLayout({ children }) {
    return <section className="PublicLegalDocumentLayout">{children}</section>;
}
